import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/core/components/shop/Cart/CartIcon.tsx
import { useEffect } from "react";
import { HiShoppingCart } from "react-icons/hi2";
import { useCart } from "@/core/context/CartContext";
const CartIcon = ({ toggleCartOverlay }) => {
    const { state } = useCart();
    useEffect(() => {
        console.log("Cart state in CartIcon:", state);
    }, [state]);
    // Calculate the total quantity of items in the cart
    const totalItems = state.items.reduce((total, item) => total + item.quantity, 0);
    return (_jsxs("div", { className: "relative mt-[3px] h-fit", children: [_jsx("button", { className: "ml-7 h-fit", onClick: () => {
                    console.log("Cart state before toggling overlay:", state);
                    toggleCartOverlay();
                }, children: _jsx(HiShoppingCart, { className: "w-[22px] h-[22px]" }) }), _jsx("span", { id: "cart-item-count", className: "absolute top-0 right-0 flex items-center min-h-fit lato-bold text-center justify-center w-5 h-5 -mt-2.5 -mr-4 text-[10.025px] text-white bg-red-500 rounded-full", children: totalItems })] }));
};
export default CartIcon;
